import React from 'react'
import { useSelector } from 'react-redux'
import { useAction } from '@agro-club/frontend-shared'
import DigitalAssetSelectors from '../../../../modules/domain/digitalAsset/selectors'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import SearchInputFilter from '../../Generics/SearchInputFilter'

const DASearchInputFilter: React.FC = () => {
  const filter = useSelector(DigitalAssetSelectors.filter)
  const filterUpdated = useAction(DigitalAssetActions.filterUpdated)

  return <SearchInputFilter filter={filter} filterUpdated={filterUpdated} placeholder="input search text" />
}

export default DASearchInputFilter
